import { render, staticRenderFns } from "./print_shcjftzd.vue?vue&type=template&id=6c226193&scoped=true&"
import script from "./print_shcjftzd.vue?vue&type=script&lang=js&"
export * from "./print_shcjftzd.vue?vue&type=script&lang=js&"
import style0 from "./print_shcjftzd.vue?vue&type=style&index=0&id=6c226193&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c226193",
  null
  
)

export default component.exports